export default __webpack_public_path__ + "static/media/pdf.2a919851.svg";